import React, { useState } from 'react';
import { IconButton, InputAdornment, OutlinedInput, SxProps, TextField, Theme as MuiTheme, Grid, createTheme, ThemeProvider } from '@mui/material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import {
    LocalizationProvider,
    MobileTimePicker,
    MobileDateTimePicker
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';

const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    '&.MuiPickersToolbarText-root.Mui-selected': {
                        color: '#1976d2',
                        fontWeight: '600',
                    },
                    '&.MuiTimePickerToolbar-ampmLabel': {
                        color: '#9e9e9e',
                        fontWeight: 'normal',
                    },
                },
            },
        },
    },
});

const DateTimePickerTextBox = ({ color, sx, placeholder, dateValue, inputValue, handleChange, isDatePicker = false, minimumDate = null }) => {

    const [showDateTimePicker, setShowDateTimePicker] = useState(false);

    return (
        <ThemeProvider theme={theme}>
            <Grid>
                <OutlinedInput
                    readOnly
                    fullWidth
                    value={inputValue}
                    inputProps={{
                        style: { color: "black", cursor: "pointer" },
                        classes: {
                            notchedOutline: {
                                borderColor: color ? color : "black",
                            },
                            input: {
                                "&::placeholder": {
                                    color: "rgba(0, 0, 0, 0.92)",
                                },
                            },
                        },
                    }}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => { setShowDateTimePicker(true) }}
                                edge="end"
                            >
                                <AccessTimeFilledIcon />
                            </IconButton>
                        </InputAdornment>
                    }
                    placeholder={placeholder}
                    onClick={() => { setShowDateTimePicker(true) }}
                // sx={{
                //     "&  .MuiFormHelperText-root.Mui-error": {
                //         backgroundColor: "transparent",
                //         margin: 0,
                //     },
                //     "&.custom-border .MuiOutlinedInput-root": {
                //         borderColor: color ? color : "white",
                //     },
                //     "& .MuiInputBase-input": {
                //         color: color ? color : "",
                //         padding: "11px !important",
                //         fontSize: "small",
                //         "&::placeholder": {
                //             color: "black",
                //         },
                //     },
                //     "& .MuiOutlinedInput-root": {
                //         "& fieldset": {
                //             borderColor: color ? color : "",
                //         },
                //         "&.Mui-focused fieldset": {
                //             borderColor: color ? color : "",
                //         },
                //     },
                //     backgroundColor: color ? color : "#FFF",
                //     borderRadius: "10px",
                //     ...sx,
                // }}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {isDatePicker
                        ? <MobileDateTimePicker
                            sx={{ display: "none" }}
                            value={dayjs(dateValue)}
                            open={showDateTimePicker}
                            onClose={() => setShowDateTimePicker(false)}
                            onChange={(date) => handleChange(date)}
                            onAccept={() => {
                                setShowDateTimePicker(false);
                            }}
                            minDateTime={dayjs(minimumDate)}
                        />
                        : <MobileTimePicker
                            sx={{ display: "none" }}
                            value={dayjs(dateValue)}
                            open={showDateTimePicker}
                            onClose={() => setShowDateTimePicker(false)}
                            onChange={(date) => handleChange(date)}
                            onAccept={() => {
                                setShowDateTimePicker(false);
                            }}
                            minTime={dayjs(minimumDate)}
                        />}
                </LocalizationProvider>
            </Grid>
        </ThemeProvider>
    )
}

export default DateTimePickerTextBox;